// extracted by mini-css-extract-plugin
export default {"about":"About_about__fvDW+","titleabout":"About_titleabout__ILe7l","text":"About_text__fzCCB","btnsave":"About_btnsave__HsrJi"};